import { matchPath } from 'react-router-dom';
import type { ResolvedConsoleHelp } from './docsBaseUrl';
import { WORKFLOWS_UI_ENABLED } from '../../../config/productFeatures';

export type { ResolvedConsoleHelp } from './docsBaseUrl';

type RouteEntry = {
  pattern: string;
  end?: boolean;
} & ResolvedConsoleHelp;

/**
 * Orden: patrones más específicos primero. `end: true` evita que `/app/agents`
 * absorba rutas hijas.
 */
const ENTRIES_ALL: RouteEntry[] = [
  { pattern: '/app/agents/:agentId/calendar/resources/:resourceId/availability', end: true, area: 'consola', slug: 'calendario-disponibilidad', title: 'Disponibilidad del recurso' },
  { pattern: '/app/agents/:agentId/calendar/bookings', end: true, area: 'consola', slug: 'calendario-reservas', title: 'Reservas del calendario' },
  { pattern: '/app/agents/:agentId/calendar/resource-types', end: true, area: 'consola', slug: 'calendario-tipos-recurso', title: 'Tipos de recurso' },
  { pattern: '/app/agents/:agentId/calendar/resources', end: true, area: 'consola', slug: 'calendario-recursos', title: 'Recursos del calendario' },
  { pattern: '/app/agents/:agentId/plugins/:pluginId/config', end: true, area: 'consola', slug: 'plugin-config', title: 'Configuración del plugin' },
  { pattern: '/app/agents/:agentId/plugins', end: true, area: 'consola', slug: 'plugins', title: 'Plugins del agente' },
  { pattern: '/app/agents/:agentId/audit', end: true, area: 'consola', slug: 'agent-audit', title: 'Auditoría del agente' },
  { pattern: '/app/agents/:agentId/s3/config', end: true, area: 'consola', slug: 's3-almacenamiento', title: 'Almacenamiento S3' },
  { pattern: '/app/agents/:agentId/demo', end: true, area: 'consola', slug: 'demo-embed', title: 'Demo y embed' },
  { pattern: '/app/workflows/:id', end: true, area: 'consola', slug: 'flujo-editor', title: 'Editor de flujo' },
  { pattern: '/app/conversations/:id', end: true, area: 'consola', slug: 'conversaciones', title: 'Detalle de conversación' },
  { pattern: '/app/style-guide', end: true, area: 'consola', slug: 'style-guide', title: 'Style guide' },
  { pattern: '/app/test', end: true, area: 'consola', slug: 'prueba-demo', title: 'Página de prueba' },
  { pattern: '/app/calendario', end: true, area: 'consola', slug: 'calendario-vista', title: 'Vista de calendario' },
  { pattern: '/app/lista-negra', end: true, area: 'consola', slug: 'lista-negra-contactos', title: 'Lista negra de contactos' },
  { pattern: '/app/message-analytics', end: true, area: 'consola', slug: 'analisis-mensajes', title: 'Análisis de mensajes' },
  { pattern: '/app/learnings', end: true, area: 'consola', slug: 'aprendizajes', title: 'Aprendizajes' },
  { pattern: '/app/settings/notifications', end: true, area: 'consola', slug: 'notificaciones', title: 'Configuración de notificaciones' },
  { pattern: '/app/notifications', end: true, area: 'consola', slug: 'notificaciones', title: 'Bandeja de notificaciones' },
  { pattern: '/app/integrations', end: true, area: 'consola', slug: 'canales', title: 'Canales e integraciones' },
  { pattern: '/app/plantillas', end: true, area: 'consola', slug: 'canales', title: 'Plantillas WhatsApp' },
  { pattern: '/app/workflows', end: true, area: 'consola', slug: 'flujos', title: 'Flujos' },
  { pattern: '/app/conversations', end: true, area: 'consola', slug: 'conversaciones', title: 'Conversaciones' },
  { pattern: '/app/agents', end: true, area: 'consola', slug: 'agentes', title: 'Agentes virtuales' },
  { pattern: '/app', end: true, area: 'consola', slug: 'inicio', title: 'Inicio de la consola' },
  { pattern: '/super/ai', end: true, area: 'super-admin', slug: 'super-ia-plataforma', title: 'Modelos IA de plataforma' },
  { pattern: '/super/orgs/:orgId', end: false, area: 'super-admin', slug: 'super-organizacion', title: 'Detalle de empresa' },
  { pattern: '/super/orgs/:orgId/pwa', end: true, area: 'super-admin', slug: 'super-organizacion-pwa', title: 'Tokens PWA (empresa)' },
  { pattern: '/super/orgs', end: true, area: 'super-admin', slug: 'super-organizaciones', title: 'Empresas (super admin)' },
  { pattern: '/super/login', end: true, area: 'super-admin', slug: 'super-organizaciones', title: 'Acceso super admin' },
];

const WORKFLOW_HELP_SLUGS = new Set(['flujos', 'flujo-editor']);

const ENTRIES = WORKFLOWS_UI_ENABLED
  ? ENTRIES_ALL
  : ENTRIES_ALL.filter((e) => !WORKFLOW_HELP_SLUGS.has(e.slug));

export function resolveConsoleHelp(pathname: string): ResolvedConsoleHelp {
  for (const e of ENTRIES) {
    const m = matchPath({ path: e.pattern, end: e.end ?? false }, pathname);
    if (m) {
      return { area: e.area, slug: e.slug, title: e.title };
    }
  }
  if (pathname.startsWith('/app')) {
    return { area: 'consola', slug: 'inicio', title: 'Inicio de la consola' };
  }
  if (pathname.startsWith('/super')) {
    return { area: 'super-admin', slug: 'super-organizaciones', title: 'Super administración' };
  }
  return { area: 'consola', slug: 'inicio', title: 'Documentación Virtual Agents' };
}
